module.exports = __webpack_public_path__ + "img/ic_dots.13a92f40.svg";